<!--
    描述：电子保函 -> 保费开票申请 -> 详情
    时间：2023-02-09
    Created by zcc
-->
<template>
  <div class="member-detail-page">
    <!-- 申请更新信息 -->
    <div class="item">
      <el-divider content-position="left"> 保费开票申请信息：</el-divider>
      <div class="main-content">
        <el-row>
          <el-col :span="6"> 业务流水号：{{ objectForm.id }} </el-col>
          <el-col :span="6">
            保费开票申请单位：{{ objectForm.enterpriseName }}
          </el-col>
          <el-col :span="6">
            统一社会信用代码：{{ objectForm.creditCode }}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6"> 保函申请编号：{{ objectForm.lgNo }} </el-col>
          <el-col :span="6">
            瀚华保函编号：{{ objectForm.guaranteeNumber }}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6"> 公司地址：{{ objectForm.enterpriseAddr }} </el-col>
          <el-col :span="6"> 公司电话：{{ objectForm.enterpriseTel }} </el-col>
          <el-col :span="6">
            银行账户开户行：{{ objectForm.accountName }}
          </el-col>
          <el-col :span="6">
            银行账户开户行账户：{{ objectForm.accountNo }}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6"> 联系人：{{ objectForm.contactsName }} </el-col>
          <el-col :span="6">
            联系人电话：{{ objectForm.contactsPhone }}
          </el-col>
          <el-col :span="6">
            联系人地址：{{ objectForm.contactsAddress }}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            发票类型：
            <span v-if="objectForm.invoiceMode == '1'">电子普票</span>
          </el-col>
          <el-col :span="6"> 发票通知邮箱地址：{{ objectForm.email }} </el-col>
        </el-row>
        <el-row>
          <el-col :span="6"> 申请人：{{ objectForm.applyUserName }} </el-col>
          <el-col :span="6"> 申请时间：{{ objectForm.createDate }} </el-col>
          <el-col :span="6"> 业务来源：{{ objectForm.sysSourceName }} </el-col>
        </el-row>
      </div>
    </div>
    <!-- 更新状态 -->
    <div class="item">
      <el-divider content-position="left">开票信息：</el-divider>
      <div class="main-content">
        <el-row>
          <el-col :span="6">
            开票申请状态：
            <span class="showStatus">
              <span v-if="objectForm.status == '0'" class="between">
                申请中
              </span>
              <span v-else-if="objectForm.status == '1'" class="success">
                已开票
              </span>
              <span v-else-if="objectForm.status == '2'" class="fail">
                申请失败
              </span>
            </span>
          </el-col>
          <el-col :span="6"> 失败原因：{{ objectForm.reason }} </el-col>
        </el-row>
        <el-row>
          <el-col :span="6"> 发票代码： {{ objectForm.invoiceCode }} </el-col>
          <el-col :span="6"> 发票号码：{{ objectForm.invoiceNumber }} </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="link-span">
            <span>
              <span class="link-title">发票下载地址：</span>
              <a :href="objectForm.invoiceUrl" target="_blank">
                <span class="link-long">{{ objectForm.invoiceUrl }}</span>
              </a>
            </span>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import * as API from "api/modules/bh/bh-premium-invoicing-application";

export default {
  name: "detail",
  data() {
    return {
      objectForm: {
        id: "", //业务流水号
        enterpriseName: "", //保费开票申请单位
        creditCode: "", //统一社会信用代码
        lgNo: "", //保函申请编号
        guaranteeNumber: "", //瀚华保函编号
        enterpriseAddr: "", //公司地址
        enterpriseTel: "", //公司电话
        accountName: "", //银行账户开户行
        accountNo: "", //银行账户开户行账户
        contactsName: "", //联系人
        contactsPhone: "", //联系人电话
        contactsAddress: "", //联系人地址
        invoiceMode: "", //发票类型:1:电子普票
        email: "", //发票通知邮箱地址
        applyUserName: "", //申请人
        createDate: "", //申请时间
        sysSourceName: "", //业务来源
        status: "", //开票申请状态(0-申请中 1-已开票 2-申请失败)
        reason: "", //失败原因
        invoiceCode: "", //发票代码
        invoiceNumber: "", //发票号码
        invoiceUrl: "", //发票下载地址
      },
    };
  },
  mounted() {},
  computed: {
    bhId() {
      return this.$route.query.id;
    },
  },
  created() {
    this.getSelectInvoiceInfo();
  },
  methods: {
    getSelectInvoiceInfo() {
      let param = {
        id: this.bhId,
      };
      API.getSelectInvoiceInfo(param).then((res) => {
        if (res.operationCode == 1) {
          Object.keys(this.objectForm).forEach(
            (key) => (this.objectForm[key] = res.data[key])
          );
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.member-detail-page {
  .item {
    .main-content {
      font-family: "Arial Normal", "Arial";
      font-weight: 400;
      font-style: normal;
      font-size: 13px;
      color: #333333;
      line-height: normal;
      padding: 0 40px;

      .el-row {
        padding: 10px 0px;
      }

      .showStatus {
        .success {
          color: #008000;
        }

        .between {
          color: #ff9900;
        }

        .fail {
          color: #ff0000;
        }
      }

      .link-span {
        display: flex;
        padding-right: 20px;

        .link-title {
          white-space: nowrap;
        }

        .link-long {
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: #409eff;
          cursor: pointer;
          border-bottom: 1px solid #fff;

          &:hover {
            border-bottom: 1px solid #409eff;
          }
        }
      }
    }
  }
}
</style>
